export default {
  AS: {
    "footer.button.billOfMaterials": "Artikellista",
    "footer.button.export": "Export",
    "footer.button.printPdf": "PDF",
    "footer.button.contactSales": "Försäljning Kontakta",
    "footer.button.addToWatchlist": "Lägg till i önskelista",
    "footer.button.requestQuote": "Offertförfrågan",
    "header.configurator.title": "Konfigurator",

    "header.links.about.label": "Om asecos",
    "header.links.about.url":
      "https://www.asecos.com/Om-asecos/Om-asecos/Om-asecos/SE_index_3187.html,",
    "header.links.terms.label": "Regler och villkor",
    "header.links.terms.url":
      "https://www.asecos.com/GTS-asecos-AB/SE_index_1724.html,",
    "header.links.imprint.label": "Impressum",
    "header.links.imprint.url":
      "https://www.asecos.com/Imprint/SE_index_1438.html,",
    "header.links.privacy.label": "Sekretesspolicy",
    "header.links.privacy.url":
      "https://www.asecos-configurator.com/SV/SE/Dataskyddspolicy",

    "dialog.requestQuote.title.success": "Förfrågan skickad",
    "dialog.requestQuote.title.requestQuote": "Offertförfrågan",
    "tab.billOfMaterials.title": "Artikellista",
    "tab.configurationSummary.title": "Sammanfattning av konfigurationen",
    "dialog.requestQuote.title.contactData": "Kontaktuppgifter",
    "dialog.requestQuote.title.companyData": "Företagsuppgifter",
    "dialog.requestQuote.label.salutation": "Titel",
    "dialog.requestQuote.select.salutation.option.female": "Fru",
    "dialog.requestQuote.select.salutation.option.male": "Herr",
    "dialog.requestQuote.select.salutation.option.none": "--",

    "dialog.requestQuote.label.firstName": "Förnamn",
    "dialog.requestQuote.label.lastName": "Efternamn",
    "dialog.requestQuote.label.email": "E-post",
    "dialog.requestQuote.label.phone": "Telefon",
    "dialog.requestQuote.label.company": "Företag",
    "dialog.requestQuote.label.country": "Land",
    "dialog.requestQuote.label.postalCode": "Postnummer",
    "dialog.requestQuote.label.city": "Ort",
    "dialog.requestQuote.label.street": "Gata",
    "dialog.requestQuote.label.number": "Nr",
    "dialog.requestQuote.label.contactHours": "Jag önskar bli uppringd",
    "dialog.requestQuote.checkbox.contactHours.option.morning": "Förmiddag",
    "dialog.requestQuote.checkbox.contactHours.option.afternoon": "Eftermiddag",
    "dialog.requestQuote.label.specialistRetailer.header":
      "Om du har en prioriterad detaljist, så registrera den här",

    "dialog.requestQuote.label.specialistRetailer.salutation": "Titel",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.female":
      "Fru",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.male":
      "Herr",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.none":
      "--",
    "dialog.requestQuote.label.specialistRetailer.company": "Företag",
    "dialog.requestQuote.label.specialistRetailer.firstName": "Förnamn",
    "dialog.requestQuote.label.specialistRetailer.lastName": "Efternamn",
    "dialog.requestQuote.label.specialistRetailer.email": "E-post",
    "dialog.requestQuote.label.specialistRetailer.city": "Ort",
    "dialog.requestQuote.url.privacyPolicy":
      "https://www.asecos-configurator.com/SV/SE/Dataskyddspolicy",
    "dialog.requestQuote.url.consentForm":
      "https://www.asecos-configurator.com/EN/SE/media/DOK_EXT_Einwilligungserklaerung-asecos-Konfigurator_IN?sprache=EN",
    "dialog.requestQuote.label.readPrivacyPolicy":
      "Jag har läst <privacyLink>sekretesspolicyn</privacyLink> och godkänner den. Jag samtycker också till behandling, användning och yppande av mina uppgifter för specialiståterförsäljare i <consentLink>enlighet med samtycket.</consentLink>",
    "dialog.requestQuote.label.comment": "Kommentar",
    "SubconfigurationNavigation.resetItem": "Återställ grupp",
    "SubconfigurationNavigation.previousItem": "Tillbaka",
    "SubconfigurationNavigation.nextItem": "Nästa",
    "form.field.error.email": "Ogiltig e-postadress",
    "form.field.error.phone": "Ogiltigt telefonnummer",
    "validation.required": "Detta fält är obligatoriskt",
    "footer.button.save": "Spara",
    "footer.button.load": "Ladda upp",

    "dialog.requestQuote.success.message":
      "Tack för ditt intresse för asecos och våra produkter. Inom några minuter kommer du att få en bekräftelse till din angivna e-postadress med dina konfigurationsdata som PDF- och JSON-fil. Med den senare kan du öppna din konfiguration igen via knappen Ladda upp. \n\nasecos produkter säljs via auktoriserade återförsäljare. Därför vidarebefordrar vi din förfrågan till en lämplig asecos-partner. Denne kommer att ta fram ett icke-bindande erbjudande enligt din konfiguration och vid behov kontakta dig ytterligare.",
    "dialog.requestQuote.success.close": "Stäng",
    "dialog.requestQuote.error.message":
      "Ett fel uppstod vid sändningen av din förfrågan. Vänligen försök igen senare.",
  },
};
